import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "../Home";
import Mint from "../Mint";
import SToken from "../SToken";
import Swap from "../Swap";
import About from "../About";

import { AnimatePresence } from 'framer-motion';

function AnimtedRoutes() {

    const location = useLocation();

    return (
            <AnimatePresence>
                <Routes location={location} key={location.path}>
                    <Route path="/" element={<Home />} />
                    <Route path="/mint" element={<Mint />} />
                    <Route path="/token" element={<SToken />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/swap" element={<Swap />} />
                </Routes>
            </AnimatePresence>
        )
}
export default AnimtedRoutes